// extracted by mini-css-extract-plugin
module.exports = {"ManagerData":"manager_ManagerData__QIgTI"};